import { gql } from '@apollo/client';

export const UPDATE_TOOL = gql`
  mutation UpdateTool($input: UpdateToolInput!) {
    updateTool(input: $input) {
      tool {
        id
        name
        description
        toolAvailabilityPeriods {
          id
          startDate
          endDate
          available
        }
      }
      errors
    }
  }
`;
